<template>
    <!-- This component is on the select tyres page for the individual tyre cards -->
    <div class="card tyre border-0 tyre-column" :data-tyre-element="tyre.st_code">
        <div class="card-header border-0 p-0">
            <!-- Tyre banners for this tyre -->
            <tyre-banners
                v-if="showBanner"
                :banners="banners"
                :tyre="tyre"
            ></tyre-banners>
            <div v-else-if="payWithPaypal">
                <div class="bg-light p-2 text-center pay-in-3 align-items-center d-flex justify-content-center">
                    <span class="d-inline-block">Pay in 3 with</span
                    ><img
                        class="ms-2 d-inline-block"
                        :src="this.baseUrl + '/assets/img/generic_images/paypal_logo.png'"
                        alt="Paypal logo"
                    />
                </div>
            </div>
        </div>
        <div
            class="card-body border d-flex flex-column grey-border rounded-lg"
            :class="[
                showBanner ? 'rounded-bottom' : ''  
            ]"
        >
            <div class="text-center row">
                <div class="col-xl-5 d-none d-xl-block">
                    <div class="tyre-image">
                        <a :href="this.baseUrl + tyre.tyre_info_url">
                            <img
                                :src="tyre.image_url"
                                class="img-fluid"
                                :alt="
                                    tyre.brand + ' ' + tyre.tyre_range + ' logo'
                                "
                                height="135"
                                @error="replaceByDefault"
                            />
                        </a>
                    </div>
                    <div class="d-block my-2">
                        <fitments
                            :fitments="tyre.fitments"
                            :fitment-summary="false"
                        ></fitments>
                    </div>
                    <awards-new
                        :awards="tyre.award_badges"
                        :tyre-url="tyre.tyre_info_url"
                    ></awards-new>
                </div>
                <div class="col-12 col-xl-7 text-start">
                    <div class="row">
                        <div class="col-12 col-sm-4 d-xl-none">
                            <div class="tyre-image">
                                <a :href="this.baseUrl + tyre.tyre_info_url">
                                    <img
                                        :src="tyre.image_url"
                                        class="img-fluid mx-auto d-block"
                                        :alt="
                                            tyre.brand + ' ' + tyre.tyre_range + ' logo'
                                        "
                                        height="135"
                                        @error="replaceByDefault"
                                    />
                                </a>
                            </div>
                        </div>
                        <div class="col-12 col-sm-8 col-xl-12">
                            <div class="tyre-size v-100">
                                <p class="mb-0">{{ tyre.tyre_range }}</p>
                                <p class="mb-0">
                                    {{ tyre.description }}
                                </p>
                            </div>
                            <div class="d-flex justify-content-between flex-column flex-xl-row">
                                <specialisms :tyre="tyre"></specialisms>
                                <rating-labels
                                :fuel="tyre.fuel"
                                :wet="tyre.wet"
                                :decibels="tyre.decibels"
                                :noise-rating="tyre.noise_rating"
                                ></rating-labels>
                            </div>
                            <div class="mt-2">
                                <reviews
                                    :identifier="`${tyre.brand_slug}-${tyre.range_slug}`"
                                    mobile-align="left"
                                ></reviews>
                            </div>
                        </div>
                    </div>
                    
                    <div class="row">
                        <template v-if="tyre.tyre_video?.length > 0">
                            <div class="col-12 col-xxl-6 mt-1">
                                <checkatyre-tyre-video
                                    custom-style="green"
                                    :multi-video="true"
                                    .tyre-video-details="tyre.tyre_video"
                                    :identifier="`${tyre.brand_slug}-${tyre.range_slug}`"
                                ></checkatyre-tyre-video>
                            </div>
                        </template>
                    </div>
                    <div class="d-flex align-items-center justify-content-between mb-2">
                        <b class="price">&pound;{{ tyre.display_price }}</b>
                        <p class="mb-0 d-flex">{{ homeDelivery ? 'Mail order' : 'Fully fitted' }} price
                            <route-tooltip
                            :home-delivery="homeDelivery"
                            class="ms-2"
                            ></route-tooltip>
                        </p>
                    </div>
                    <div class="d-flex flex-sm-column flex-md-row flex-lg-column gap-3">
                        <select
                            name="quantity"
                            id="quantity"
                            class="form-control"
                            v-model="quantity"
                        >
                            <option v-for="index in 5" :key="index" :value="index">
                                {{ index }} tyre{{ index > 1 ? 's' : '' }}
                            </option>
                        </select>
                        <button
                            class="btn w-100"
                            :class="newButtonColour"
                            @click="
                                this.$parent.$parent.addTyreToBasket(
                                    tyre.st_code,
                                    quantity
                                )
                            "
                        >
                            {{ newButtonText }}
                        </button>
                    </div>
                    <earliest-fitting
                        v-if="
                            postcode &&
                            this.$parent.$parent.homeDelivery == false
                        "
                        :fitting-today="tyre.fitting_today"
                        :fitting-tomorrow="tyre.fitting_tomorrow"
                        :earliest-fitting-date="tyre.earliest_fitting_date"
                        :postcode="postcode"
                    ></earliest-fitting>
                </div>
            </div>
        </div>
        <div
            v-if="featured"
            class="card-footer text-center"
            :class="tyre.view_class"
        >
            <b class="d-inline-block">{{ tyre.view_label_1 }} {{ tyre.view_label_2 }}</b>
            <a class="d-inline-block ms-3" :href="'/' + tyre.link">{{ tyre.link_text }}</a>
        </div>
    </div>
</template>

<script>
    import tyre from "@shared/mixins/tyre";
    export default {
        props: ['tyre', 'banners', 'basket', 'postcode', 'featured', 'payWithPaypal', 'homeDelivery', 'postcode'],
        mixins: [tyre],
        data() {
            return {
                quantity: this.$parent.$parent.quantity,
                featuredTopSpotFlag: false,
            };
        },
        computed: {
            //mirroring tyreText and buttonColour computed vars from mixin.
            newButtonText() {
                return this.inBasket ? 'In Basket' : 'Buy now';
            },
            newButtonColour() {
                return this.inBasket ? 'btn-secondary' : 'btn-primary';
            }
        }
    };
</script>
<style lang="scss" scoped>
    .tyre {
        .pay-in-3 {
            font-size: 18px;
            color: #203674;
        }
        .card-header {
            background-color: transparent;
        }
        .card-body {
            position: relative;
            padding-bottom: 10px;
            &.featured {
                border-bottom-left-radius: 0 !important;
                border-bottom-right-radius: 0 !important;
            }
            .tyre-image {
                position: relative;
                height: auto;
                @media screen and (max-width: 576px) {
                    overflow: hidden;
                    max-height: 150px;
                } 
            }
            .price {
                font-size: 27px;
            }
            .per {
                font-size: 14px;
            }
            .tyre-info-badge {
                position: absolute;
                bottom: 5px;
                left: -5px;
                text-align: left;
                div:nth-of-type(2) {
                    margin-top: 5px;
                }
                .fa-star {
                    color: #ffc107;
                }
            }
        }
    }
</style>